export const subtitle = "text-sm text-text-secondary mb-6";
export const gridContainer = "grid grid-cols-1 lg:grid-cols-3 gap-6 items-start";
export const sidebarContainer = "lg:col-span-1 space-y-6";

export const profileCard = "bg-bg-surface border border-border-color rounded-2xl p-6 flex flex-col items-center text-center";
export const avatar = "w-20 h-20 rounded-full bg-primary-teal/20 border-2 border-primary-teal flex items-center justify-center text-primary-teal text-2xl font-bold mb-4 shadow-lg";
export const profileName = "text-lg font-bold text-text-primary mb-1";
export const profileEmail = "text-sm text-text-secondary mb-4";
export const verifiedBadge = "px-3 py-1 rounded-full text-xs font-semibold bg-green-500/10 text-green-500 border border-green-500/25";
export const verifiedIcon = "fa-solid fa-check-circle mr-1.5";

export const tabsContainer = "bg-bg-surface border border-border-color rounded-2xl p-4 flex flex-col gap-1.5";
export const tabIcon = "text-base";

export const contentPanel = "lg:col-span-2 bg-bg-surface border border-border-color rounded-2xl p-6 md:p-8";

export const getTabClass = (isActive: boolean) =>
  `w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all cursor-pointer ${
    isActive
      ? "bg-primary-accent text-white shadow-lg shadow-primary-accent/15"
      : "text-text-secondary hover:text-text-primary hover:bg-bg-elevated"
  }`;
